<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Staff Member', apiMethod: 'StaffMembers', form: () => import('../forms/StaffMemberForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Blend Receival', apiMethod: 'BlendReceivals', parentForeignKey: 'checkedByStaffMemberId', form: () => import('../forms/BlendReceivalForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Cleaning', apiMethod: 'Cleanings', parentForeignKey: 'staffMemberId', form: () => import('../forms/CleaningForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Facility Setup', apiMethod: 'FacilitySetups', parentForeignKey: 'staffMemberId', form: () => import('../forms/FacilitySetupForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Qualification', apiMethod: 'Qualifications', parentForeignKey: 'staffMemberId', form: () => import('../forms/QualificationForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Blend Receival Checked By Staff Members', value: 'checkedByStaffMemberId', isCard: true, table: () => import('../tables/BlendReceivalsTable') },
                    { text: 'Cleanings', value: 'staffMemberId', isCard: true, table: () => import('../tables/CleaningsTable') },
                    { text: 'Facility Setups', value: 'staffMemberId', isCard: true, table: () => import('../tables/FacilitySetupsTable') },
                    { text: 'Qualifications', value: 'staffMemberId', isCard: true, table: () => import('../tables/QualificationsTable') },
                ],
                mainForm: () => import('../forms/StaffMemberForm'),
                claimName: 'StaffMembers',
                apiMethod: 'StaffMembers',
            }
        }
    };
</script>
